import parse from 'html-react-parser';
import { useEffect, useState } from 'react';

import { AccordionContent, AccordionItem, AccordionTrigger } from '@/components/core/Accordion';
import { useDataModel } from '@/hooks/useDataModel';
import { useOrganization } from '@/hooks/useOrganization';
import { useTranslation } from '@/hooks/useTranslation';
import { useUser } from '@/hooks/useUser';
import { getFilter } from '@/services/angularjs-bridge';

import { ItemAttribute } from '../export-media-asset.types';

interface ItemsMediaEmptyProps {
    itemAttributes: ItemAttribute;
    itemPrimaryKey: string;
}

const ItemsMediaEmpty = ({ itemAttributes, itemPrimaryKey }: ItemsMediaEmptyProps) => {

    const { t } = useTranslation();
    const { dataModel } = useDataModel();
    const [title, setTitle] = useState('');
    const { organization } = useOrganization();
    const { user } = useUser();

    useEffect(() => {

        if (!dataModel) {
            return;
        }

        const layout = dataModel.layout('media_asset');
        if (layout) {
            let title = itemPrimaryKey;

            if (layout.layoutOptions && layout.layoutOptions.itemTitleFilter) {
                const filterName = layout.layoutOptions.itemTitleFilter;
                const titleFilterFn = getFilter(filterName);
                title = titleFilterFn(itemAttributes, user, organization);
            }

            setTitle(title);
        }

    }, [dataModel, itemAttributes, itemPrimaryKey, organization, user]);

    return (
        <AccordionItem value={itemPrimaryKey} className="tw-shadow tw-px-4 tw-mt-4 tw-bg-white">
            <AccordionTrigger>
                <span>{parse(title)}</span>
            </AccordionTrigger>

            <AccordionContent>
                <div className="tw-flex tw-flex-row tw-flex-wrap tw-py-6">
                    <p>{t('MEDIA_ASSET_EXPORT.EMPTY')}</p>
                </div>
            </AccordionContent>

        </AccordionItem>
    );
};

export { ItemsMediaEmpty };
